import { Component, OnInit } from '@angular/core';
import { WorklistService } from '../worklist.service';
import { ParameterService } from '../../../shared/services/parameter/parameter.service';
import { AppMessageService } from '../../../shared/services/app-message/app-message.service';


interface WorklistFilter {
  search?: string;
  startDate?: Date;
  endDate?: Date;
  teamIds?: number[];
  statusIds?: number[];
  priorityIds?: number[];
}

interface WorklistItem {
  id: number;
  title: string;
  description: string;
  workDate: Date;
  alarmTime: Date;
  priorityId: number;
  statusId: number;
  teamIds: number[];
  isRecurring: boolean;
  createdAt: Date;
  updatedAt: Date;
  completedAt: Date;
  logs?: any[];
}

@Component({
  selector: 'app-worklist',
  templateUrl: './worklist.component.html',
  styleUrl: './worklist.component.scss'
})
export class WorklistComponent implements OnInit{
  filter: WorklistFilter = {
    search: undefined,
    startDate: undefined,
    endDate: undefined,
    teamIds: [],
  };

  filterCollaps: boolean = false;
  loading: boolean = false;
  showCollapse: boolean = true;

  worklistData: WorklistItem[] = [];
  selectedWork: WorklistItem | null = null;
  showUpdateModal: boolean = false;
  showCreateModal: boolean = false;
  showLogModal: boolean = false;

  first = 0;
  rows = 10

  teamsOptions: any[] = [];
  priorityOptions: any[] = [];
  statusOptions: any[] = [];


  data: any[] = [];


  statusLogsVisible = false;
  statusLogs: any[] = [];
  constructor(
    private readonly service: WorklistService,
    private readonly parameterService: ParameterService,
    private readonly messageService: AppMessageService
  ) { }

  ngOnInit() {

    this.loadParameterOptions();
    this.getList();
  }

  loadParameterOptions() {
    this.parameterService
      .getParameterValues('data-group', 'teams')
      .subscribe((res) => {
        this.teamsOptions = res?.datas?.values.map((data: any) => {
          return { label: data.valueObject.name.value, value: data?.valueObject.id.value };
        });
      });

    this.parameterService
      .getParameterValues('data-group', 'statuses')
      .subscribe((res) => {
        this.statusOptions = res?.datas?.values.map((data: any) => {
          return { label: data.valueObject.name.value, value: data?.valueObject.id.value };
        });
      });

    this.parameterService
      .getParameterValues('data-group', 'priority')
      .subscribe((res) => {
        this.priorityOptions = res?.datas?.values.map((data: any) => {
          return { label: data.valueObject.name.value, value: data?.valueObject.id.value };
        });
      });
  }

  getList() {
    this.loading = true;
    this.service.getFilteredList({}).subscribe({
      next: (res: any) => {
        this.data = res.data
      },
      error: (err) => {
        this.messageService.errorToast("", err) //res.message
      }
    });
  }

  getFilteredList(filter: any) {
    this.loading = true;
    this.service.getFilteredList(filter).subscribe({
      next: (response: any) => {
        this.data = response.data;
        this.loading = false;
      },
      error: (error) => {
        console.error('Liste yüklenirken hata oluştu:', error);
        this.loading = false;
      }
    });
  }

  clearFilter() {
    this.filter = {
      search: undefined,
      startDate: undefined,
      endDate: undefined,
      teamIds: [],
    };
    this.getList();
  }

  initilize() {
    this.showCreateModal = true;
  }


  openUpdateModal(work: WorklistItem) {
    this.selectedWork = { ...work };
    this.showUpdateModal = true;
  }

  openLogModal(work: WorklistItem) {
    this.selectedWork = work;
    this.showLogModal = true;
  }

  onWorkCreated(work: WorklistItem) {
    this.showCreateModal = false;
    this.getList();
  }

  onWorkUpdated(work: WorklistItem) {
    this.showUpdateModal = false;
    this.getList();
  }

  getTeamNames(teamIds: number[]): string {
    if (!teamIds || teamIds.length === 0) return '';

    const teamNames = teamIds
      .map(id => this.teamsOptions.find(t => t.value === id)?.label)
      .filter((name): name is string => !!name);

    return teamNames.join(', ');
  }

  getPriorityName(priorityId: number): string {
    const priority = this.priorityOptions.find(p => p.value === priorityId);
    return priority ? priority.label : '';
  }

  getStatusName(statusId: number): string {
    const status = this.statusOptions.find(s => s.value === statusId);
    return status ? status.label : '';
  }

  truncateText(text: string, limit: number = 100): string {
    if (!text) return '';
    return text.length > limit ? text.substring(0, limit) + '...' : text;
  }

  formatDate(date: Date): string {
    if (!date) return '';
    return new Date(date).toLocaleDateString('tr-TR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  }

  formatDateTime(date: Date): string {
    if (!date) return '';
    return new Date(date).toLocaleDateString('tr-TR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }


  openStatusHistoryModal(data: any) {
    this.service.getStatusLogs(data.id).subscribe({
      next: (res) => {
        this.statusLogs = res.data.statusLogs
        const condition = res.data.statusLogs;
        this.statusLogsVisible = condition.length > 0;

        res?.data?.statusLogs?.length > 0 ? this.messageService.successToast("", res.message) : this.messageService.errorToast("",res.message)

      },
      error: (err) => {
        const message =
          err?.error?.message ??
          err?.message ?? ''
        this.messageService.errorToast("", message);
      }
    })
  }

  closeStatusLogsDialog() {
    this.statusLogsVisible = false;
  }
}

